import type { AxiosInstance } from 'axios';
import axios from 'axios';
import { SELF_SERVICE_API_URL } from 'config';
import requestHeaders from '../interceptors/requestHeaders';
import retryOrHandleError from '../interceptors/retryOrHandleError';

const createAPI = (): AxiosInstance => {
  const api: AxiosInstance = axios.create({
    baseURL: SELF_SERVICE_API_URL,
    withCredentials: true,
  });

  api.interceptors.request.use(requestHeaders);
  api.interceptors.response.use(undefined, retryOrHandleError);

  return api;
};

export default createAPI;
